// eslint-disable-next-line no-unused-vars
import axios from 'axios'

import router from '../router/index'
import baseURL from '../config/config'

axios.interceptors.request.use(
  function (config) {
    if (config.url != '/api/upload/upload') {
      const token = localStorage.getItem('incredible-k')
      if (token) {
        config.data = { token, ...config.data }
      }
    }

    // Do something before request is sent
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  },
)
axios.interceptors.response.use(
  (response) => {
    // Do something with response data
    if (response.data.code === 201 || response.data.code === 202) {
      router.push('/login')
      localStorage.removeItem('incredible-k')

      return
    }
    return response
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error)
  },
)
if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = baseURL
}

export default axios
